/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  no-console,
*/
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './dropbox-signin-button.scss';
import { queryParams } from 'hellospa/common/utils/fetch';
import DropboxSvg from '../../../../public/images/v2/modules/home/integrations/dropbox_icon.svg';

export default class DropboxSignInButton extends React.Component {

  static propTypes = {
    redirectUrl: PropTypes.string,
    isSignup: PropTypes.bool,
  };

  onSignIn = () => {
    const { redirectUrl } = this.props;
    const qs = queryParams({
      on_login_redirect_url: redirectUrl || null,
      utm_source: 'dropbox-signin',
    });
    const authUrl = `/account/dropboxLogin${qs}`;
    window.location.replace(authUrl);
  };

  render() {
    return (
      <div className="dropbox-signin-button">
        <button className="dropbox-signin-button__button foundation-exempt" onClick={this.onSignIn}>
          <div className="dropbox-signin-button__left">
            <img src={DropboxSvg} className="dropbox-signin-button__icon" alt="" aria-hidden="true" />
          </div>
          <div className="dropbox-signin-button__right">
            {this.props.isSignup ? (
              <FormattedMessage
                id=""
                description="sign up with Dropbox button"
                defaultMessage="Sign up with Dropbox" />
            ) : (
              <FormattedMessage
                id=""
                description="sign in with Dropbox button"
                defaultMessage="Sign in with Dropbox" />
            )}
          </div>
        </button>
      </div>
    );
  }
}
